import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DownOutlined, CheckOutlined } from "@ant-design/icons";
import { Select, Divider } from "antd";
import UserReferenceField from "../Users/UI/UserReferenceField";
import Notification from "../Notification/Notification";
import "./SiteLayout.css";
import {
  getYearOfDisplayUserByUser,
  getSelectedOffsetYear,
} from "../YearsUser/Application/YearsUser.business";
import { getYearOfDisplayByUserSelector } from "../YearsUser/Infrastructure/YearsUser.reducer";
/// import { saveSelectedOffsetYear } from "../YearsUser/Infrastructure/YearsUser.store";
import { getSelectedOffsetYearSelector } from "../YearsUser/Infrastructure/YearsUser.reducer";
import {
  getOwnersByProject,
  getSelectedProject,
} from "../Owners/Application/Owners.bussines";
import { getsetOwnersByProjectSelector } from "../Owners/Infrastructure/Owners.reducer";
import { saveSelectedProject } from "../Owners/Infrastructure/Owners.store";
import { EditIcon } from "../Utils/UI/Text";
import { useNavigate } from "react-router-dom";

const UserMenu = () => {
  const yearOfDisplay = useSelector(getYearOfDisplayByUserSelector);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const ownersByProject = useSelector(getsetOwnersByProjectSelector);
  const offsetYear = useSelector(getSelectedOffsetYearSelector);
  const navigate = useNavigate();

  useEffect(() => {
    if (
      selectedYear === null &&
      Array.isArray(yearOfDisplay?.years) &&
      yearOfDisplay.years.length > 0
    ) {
      const latestYear = Math.max(...yearOfDisplay.years.map(Number));
      setSelectedYear(latestYear);
      getSelectedOffsetYear(latestYear);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [yearOfDisplay]);

  const onChange = (value) => {
    setSelectedYear(value);
    // saveSelectedOffsetYear(value);
    getSelectedOffsetYear(value);
  };

  const onSearch = (value) => {
    setSelectedYear(value);
    // saveSelectedOffsetYear(value);
    getSelectedOffsetYear(value);
  };

  const handleProjectChange = (value) => {
    setSelectedProject(value);
    getSelectedProject(value);
  };

  const handleProjectSearch = (value) => {
    setSelectedProject(value);
    getSelectedProject(value);
  };

  // Initialize years
  useEffect(() => {
    setSelectedYear(offsetYear);
    getYearOfDisplayUserByUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const loadOwnerProjects = async () => {
      try {
        await getOwnersByProject();
        if (
          Array.isArray(ownersByProject) &&
          ownersByProject.length > 0 &&
          !selectedProject
        ) {
          const firstProject = ownersByProject[0];
          setSelectedProject(firstProject.id);
          saveSelectedProject(firstProject.id);
        }
      } catch (error) {
        console.error("Failed to load owner projects:", error);
      }
    };

    loadOwnerProjects();
  }, []);


useEffect(() => {
  const loadOwnerProjects = async () => {
    try {
      await getOwnersByProject();
      if (Array.isArray(ownersByProject) && ownersByProject.length > 0 && !selectedProject) {
        const firstProject = ownersByProject[0];
        setSelectedProject(firstProject.id);
        saveSelectedProject(firstProject.id);
      }
    } catch (error) {
      console.error("Failed to load owner projects:", error);
    }
  };
  
  loadOwnerProjects();
}, []);

  const yearOptions = Array.isArray(yearOfDisplay?.years)
    ? yearOfDisplay.years.map((year) => ({
        value: year,
        label: year,
      }))
    : [];
  const handleEditClick = () => {
    navigate("/my-profile");
  };

  const projectOptions = Array.isArray(ownersByProject)
    ? ownersByProject.map((project) => ({
        value: project.id,
        label: project.projectNameForSearcher,
      }))
    : [];

  useEffect(() => {
    if (projectOptions.length > 0 && selectedProject === null) {
      setSelectedProject(projectOptions[0].value); // selecciona el primero
    }
  }, [projectOptions]);

  return (
    <Notification
      notificacionStyle="userDetails"
      icon={<DownOutlined className="downOutlined" />}
      type="text"
      description={
        <div>
          <UserReferenceField
            stylesUsername="usernameSecond"
            occupationStyle="occupationSecond"
            dashboard
            container="containerSecond"
            containerText="containerTextSecond"
            occupation="Dev"
            dot
            size={64}
            showEditIcon
            editComponent={
              <EditIcon
                TooltipEdit="Editar perfil"
                onClick={handleEditClick}
                color="#9B9B9B"
                fontSize={16}
                className="user-edit-icon"
              />
            }
            children={({ roleObject, selectedRol, handleRoleClick }) => {
              return (
                <div className="grid-notification">
                  <div className="dividir-user">
                    <Divider className="dividir-user-text">
                      Tipo de usuario
                    </Divider>
                    <div className="container-role">
                      {roleObject?.role?.map((role) => (
                        <span
                          className="role"
                          key={role.roleName}
                          onClick={() => handleRoleClick(role.roleName)}
                        >
                          <div>
                            <span className="container-role-text">
                              {role.translatedRoles}
                            </span>
                            {role.roleName === selectedRol && (
                              <CheckOutlined className="check-outlined" />
                            )}
                          </div>
                        </span>
                      ))}
                    </div>

                    {roleObject?.role?.map((role) =>
                      role.translatedRoles === "Partner" ? (
                        <div key={role.roleName}>
                          <Divider className="dividir-user-text">
                            Año de visualización
                          </Divider>
                          <div className="dividir-container-select">
                            <Select
                              className="select-custom-dropdown"
                              showSearch
                              placeholder="Seleccionar año"
                              optionFilterProp="label"
                              defaultValue={selectedYear}
                              onChange={onChange}
                              onSearch={onSearch}
                              dropdownClassName="custom-dropdown"
                              options={yearOptions}
                            />
                          </div>
                        </div>
                      ) : null
                    )}
                    {roleObject?.role?.map((role) =>
                      role.roleName === "owner" ? (
                        <div key={role.roleName}>
                          <Divider className="dividir-user-text">
                            Los proyectos
                          </Divider>
                          <div className="dividir-container-select">
                            {projectOptions.length > 0 && (
                              <Select
                                className="select-custom-dropdown"
                                showSearch
                                placeholder="Seleccionar proyecto"
                                optionFilterProp="label"
                                defaultValue={selectedProject}
                                onChange={handleProjectChange}
                                onSearch={handleProjectSearch}
                                dropdownClassName="custom-dropdown"
                                options={projectOptions}
                              />
                            )}
                          </div>
                        </div>
                      ) : null
                    )}
                  </div>
                </div>
              );
            }}
          />
        </div>
      }
    />
  );
};

export default UserMenu;
